var _a;
/** @hidden */
export var allEvents = 'scheduler.allEvents';
/** @hidden */
export var allDay = 'scheduler.allDay';
/** @hidden */
export var today = 'scheduler.today';
/** @hidden */
export var timelineViewTitle = 'scheduler.timelineViewTitle';
/** @hidden */
export var weekViewTitle = 'scheduler.weekViewTitle';
/** @hidden */
export var workWeekViewTitle = 'scheduler.workWeekViewTitle';
/** @hidden */
export var agendaViewTitle = 'scheduler.agendaViewTitle';
/** @hidden */
export var dayViewTitle = 'scheduler.dayViewTitle';
/** @hidden */
export var monthViewTitle = 'scheduler.monthViewTitle';
/** @hidden */
export var deleteTitle = 'scheduler.deleteTitle';
/** @hidden */
export var previousTitle = 'scheduler.previousTitle';
/** @hidden */
export var nextTitle = 'scheduler.nextTitle';
/** @hidden */
export var showFullDay = 'scheduler.showFullDay';
/** @hidden */
export var showWorkDay = 'scheduler.showWorkDay';
/** @hidden */
export var editorOccurrence = 'scheduler.editOccurrence';
/** @hidden */
export var editorSeries = 'scheduler.editSeries';
/** @hidden */
export var editorRecurringConfirmation = 'scheduler.editRecurringConfirmation';
/** @hidden */
export var editorRecurringDialogTitle = 'scheduler.editRecurringDialogTitle';
/** @hidden */
export var editorSave = 'scheduler.editSave';
/** @hidden */
export var editorCancel = 'scheduler.editCancel';
/** @hidden */
export var editorTitle = 'scheduler.editorTitle';
/** @hidden */
export var editorEventTitle = 'scheduler.editorEventTitle';
/** @hidden */
export var editorEventStart = 'scheduler.editorEventStart';
/** @hidden */
export var editorEventStartTimeZone = 'scheduler.editorEventStartTimeZone';
/** @hidden */
export var editorEventEnd = 'scheduler.editorEventEnd';
/** @hidden */
export var editorEventEndTimeZone = 'scheduler.editorEventEndTimeZone';
/** @hidden */
export var editorEventAllDay = 'scheduler.editorEventAllDay';
/** @hidden */
export var editorEventDescription = 'scheduler.editorEventDescription';
/** @hidden */
export var editorEventSeparateTimeZones = 'scheduler.editorEventSeparateTimeZones';
/** @hidden */
export var editorEventTimeZone = 'scheduler.editorEventTimeZone';
/** @hidden */
export var recurrenceEditorRepeat = 'scheduler.recurrenceEditorRepeat';
/** @hidden */
export var recurrenceEditorDailyInterval = 'scheduler.recurrenceEditorDailyInterval';
/** @hidden */
export var recurrenceEditorDailyRepeatEvery = 'scheduler.recurrenceEditorDailyRepeatEvery';
/** @hidden */
export var recurrenceEditorWeeklyInterval = 'scheduler.recurrenceEditorWeeklyInterval';
/** @hidden */
export var recurrenceEditorWeeklyRepeatEvery = 'scheduler.recurrenceEditorWeeklyRepeatEvery';
/** @hidden */
export var recurrenceEditorWeeklyRepeatOn = 'scheduler.recurrenceEditorWeeklyRepeatOn';
/** @hidden */
export var recurrenceEditorMonthlyDay = 'scheduler.recurrenceEditorMonthlyDay';
/** @hidden */
export var recurrenceEditorMonthlyInterval = 'scheduler.recurrenceEditorMonthlyInterval';
/** @hidden */
export var recurrenceEditorMonthlyRepeatEvery = 'scheduler.recurrenceEditorMonthlyRepeatEvery';
/** @hidden */
export var recurrenceEditorMonthlyRepeatOn = 'scheduler.recurrenceEditorMonthlyRepeatOn';
/** @hidden */
export var recurrenceEditorYearlyOf = 'scheduler.recurrenceEditorYearlyOf';
/** @hidden */
export var recurrenceEditorYearlyRepeatEvery = 'scheduler.recurrenceEditorYearlyRepeatEvery';
/** @hidden */
export var recurrenceEditorYearlyRepeatOn = 'scheduler.recurrenceEditorYearlyRepeatOn';
/** @hidden */
export var recurrenceEditorYearlyInterval = 'scheduler.recurrenceEditorYearlyInterval';
/** @hidden */
export var recurrenceEditorFrequenciesDaily = 'scheduler.recurrenceEditorFrequenciesDaily';
/** @hidden */
export var recurrenceEditorFrequenciesMonthly = 'scheduler.recurrenceEditorFrequenciesMonthly';
/**  @hidden */
export var recurrenceEditorFrequenciesNever = 'scheduler.recurrenceEditorFrequenciesNever';
/** @hidden */
export var recurrenceEditorFrequenciesWeekly = 'scheduler.recurrenceEditorFrequenciesWeekly';
/** @hidden */
export var recurrenceEditorFrequenciesYearly = 'scheduler.recurrenceEditorFrequenciesYearly';
/** @hidden */
export var recurrenceEditorOffsetPositionsFirst = 'scheduler.recurrenceEditorOffsetPositionsFirst';
/** @hidden */
export var recurrenceEditorOffsetPositionsSecond = 'scheduler.recurrenceEditorOffsetPositionsSecond';
/** @hidden */
export var recurrenceEditorOffsetPositionsThird = 'scheduler.recurrenceEditorOffsetPositionsThird';
/** @hidden */
export var recurrenceEditorOffsetPositionsFourth = 'scheduler.recurrenceEditorOffsetPositionsFourth';
/** @hidden */
export var recurrenceEditorOffsetPositionsLast = 'scheduler.recurrenceEditorOffsetPositionsLast';
/** @hidden */
export var recurrenceEditorWeekdaysDay = 'scheduler.recurrenceEditorWeekdaysDay';
/** @hidden */
export var recurrenceEditorWeekdaysWeekday = 'scheduler.recurrenceEditorWeekdaysWeekday';
/** @hidden */
export var recurrenceEditorWeekdaysWeekendday = 'scheduler.recurrenceEditorWeekdaysWeekendday';
/** @hidden */
export var recurrenceEditorEndAfter = 'scheduler.recurrenceEditorEndAfter';
/** @hidden */
export var recurrenceEditorEndOccurrence = 'scheduler.recurrenceEditorEndOccurrence';
/** @hidden */
export var recurrenceEditorEndLabel = 'scheduler.recurrenceEditorEndLabel';
/** @hidden */
export var recurrenceEditorEndNever = 'scheduler.recurrenceEditorEndNever';
/** @hidden */
export var recurrenceEditorEndOn = 'scheduler.recurrenceEditorEndOn';
/** @hidden */
export var editorDelete = 'scheduler.editorDelete';
/** @hidden */
export var deleteConfirmation = 'scheduler.deleteConfirmation';
/** @hidden */
export var deleteRecurringConfirmation = 'scheduler.deleteRecurringConfirmation';
/** @hidden */
export var deleteOccurrence = 'scheduler.deleteOccurrence';
/** @hidden */
export var deleteSeries = 'scheduler.deleteSeries';
/** @hidden */
export var deleteDialogTitle = 'scheduler.deleteDialogTitle';
/** @hidden */
export var deleteRecurringDialogTitle = 'scheduler.deleteRecurringDialogTitle';
/** @hidden */
export var dateTitle = 'scheduler.dateTitle';
/** @hidden */
export var timeTitle = 'scheduler.timeTitle';
/** @hidden */
export var eventTitle = 'scheduler.eventTitle';
/** @hidden */
export var editorValidationRequired = 'scheduler.editorValidationRequired';
/** @hidden */
export var editorValidationStart = 'scheduler.editorValidationStart';
/** @hidden */
export var editorValidationEnd = 'scheduler.editorValidationEnd';
/** @hidden */
export var noEvents = 'scheduler.noEvents';
/**
 * @hidden
 */
export var messages = (_a = {},
    _a[editorValidationRequired] = 'Field is required.',
    _a[editorValidationStart] = 'Start time must be be before End time.',
    _a[editorValidationEnd] = 'End time must be after Start time.',
    _a[allEvents] = 'All events',
    _a[allDay] = 'all day',
    _a[today] = 'Today',
    _a[dayViewTitle] = 'Day',
    _a[monthViewTitle] = 'Month',
    _a[weekViewTitle] = 'Week',
    _a[workWeekViewTitle] = 'Work Week',
    _a[timelineViewTitle] = 'Timeline',
    _a[agendaViewTitle] = 'Agenda',
    _a[deleteTitle] = 'Delete',
    _a[previousTitle] = 'Previous',
    _a[nextTitle] = 'Next',
    _a[showFullDay] = 'Show full day',
    _a[showWorkDay] = 'Show business hours',
    _a[editorOccurrence] = 'Edit current occurrence',
    _a[editorSeries] = 'Edit the series',
    _a[editorRecurringConfirmation] = 'Do you want to edit only this event occurrence or the whole series?',
    _a[editorRecurringDialogTitle] = 'Edit Recurring Item',
    _a[editorSave] = 'Save',
    _a[editorCancel] = 'Cancel',
    _a[editorDelete] = 'Delete',
    _a[editorTitle] = 'Event',
    _a[editorEventTitle] = 'Title',
    _a[editorEventStart] = 'Start',
    _a[editorEventStartTimeZone] = 'Start Time Zone',
    _a[editorEventEnd] = 'End',
    _a[editorEventEndTimeZone] = 'End Time Zone',
    _a[editorEventAllDay] = 'All Day Event',
    _a[editorEventDescription] = 'Description',
    _a[editorEventSeparateTimeZones] = 'End in different Time Zone',
    _a[editorEventTimeZone] = 'Specify Time Zone',
    _a[recurrenceEditorRepeat] = 'Repeat',
    _a[recurrenceEditorDailyInterval] = 'day(s)',
    _a[recurrenceEditorDailyRepeatEvery] = 'Repeat every',
    _a[recurrenceEditorWeeklyInterval] = 'week(s)',
    _a[recurrenceEditorWeeklyRepeatEvery] = 'Repeat every',
    _a[recurrenceEditorWeeklyRepeatOn] = 'Repeat on',
    _a[recurrenceEditorMonthlyDay] = 'Day',
    _a[recurrenceEditorMonthlyInterval] = 'month(s)',
    _a[recurrenceEditorMonthlyRepeatEvery] = 'Repeat every',
    _a[recurrenceEditorMonthlyRepeatOn] = 'Repeat on',
    _a[recurrenceEditorYearlyOf] = 'of',
    _a[recurrenceEditorYearlyRepeatEvery] = 'Repeat every',
    _a[recurrenceEditorYearlyRepeatOn] = 'Repeat on',
    _a[recurrenceEditorYearlyInterval] = 'year(s)',
    _a[recurrenceEditorFrequenciesDaily] = 'Daily',
    _a[recurrenceEditorFrequenciesMonthly] = 'Monthly',
    _a[recurrenceEditorFrequenciesNever] = 'Never',
    _a[recurrenceEditorFrequenciesWeekly] = 'Weekly',
    _a[recurrenceEditorFrequenciesYearly] = 'Yearly',
    _a[recurrenceEditorOffsetPositionsFirst] = 'First',
    _a[recurrenceEditorOffsetPositionsSecond] = 'Second',
    _a[recurrenceEditorOffsetPositionsThird] = 'Third',
    _a[recurrenceEditorOffsetPositionsFourth] = 'Fourth',
    _a[recurrenceEditorOffsetPositionsLast] = 'Last',
    _a[recurrenceEditorWeekdaysDay] = 'Day',
    _a[recurrenceEditorWeekdaysWeekday] = 'Weekday',
    _a[recurrenceEditorWeekdaysWeekendday] = 'Weekend Day',
    _a[recurrenceEditorEndAfter] = 'After',
    _a[recurrenceEditorEndOccurrence] = 'occurrence(s)',
    _a[recurrenceEditorEndLabel] = 'End',
    _a[recurrenceEditorEndNever] = 'Never',
    _a[recurrenceEditorEndOn] = 'On',
    _a[deleteConfirmation] = 'Are you sure you want to delete this event?',
    _a[deleteRecurringConfirmation] = 'Do you want to delete only this event occurrence or the whole series?',
    _a[deleteOccurrence] = 'Delete current occurrence',
    _a[deleteSeries] = 'Delete the series',
    _a[deleteDialogTitle] = 'Delete Event',
    _a[deleteRecurringDialogTitle] = 'Delete Recurring Item',
    _a[dateTitle] = 'Date',
    _a[timeTitle] = 'Time',
    _a[eventTitle] = 'Event',
    _a[noEvents] = 'no events',
    _a);
